import { ReactNode } from "react";
import Icon from "../icons/icon";

interface EmptyProps {
  icon?: ReactNode;
  title?: string;
  subtitle?: string;
  color?: string;
  className?: string;
}

const Empty = ({ icon, title, subtitle, color, className }: EmptyProps) => {
  return (
    <div
      className={`flex flex-col w-full h-full justify-center items-center gap-4 ${
        className ?? ""
      }`}
    >
      {icon && (
      <div className="p-4 bg-white rounded-full">
        <Icon icon={icon} className="h-[40px] w-[40px]" />
      </div>
      )}
      <p className="text-xl text-center font-bold font-evolventa">{title}</p>
      <p className="text-gray text-center">{subtitle}</p>
    </div>
  );
};

export default Empty;
